var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserRegistrationLayout',{staticClass:"set-owner"},[(!_vm.isLoading)?_c('div',{staticClass:"change-owner"},[(!_vm.errorMsg)?_c('div',[_vm._v("Workspace owner was changed successfully")]):_c('div',[_c('div',[_vm._v("Failed setting new workspace owner:")]),_c('div',[_vm._v(_vm._s(_vm.errorMsg))])])]):_c('AppLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }